module.exports = __webpack_public_path__ + "media/wo_jiao_jian_guo_ni_ne.a265514d.mp3";